import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { useEffect, useState } from "react";
import axios from "axios";
import CreaEquipos from "views/Crea/CreaEquipos";
import ProtectedRoute from "./Protected";

const Equipos = () => {
  const [list1, setList1] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const urlendpoint =
    "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerEquipos";

  useEffect(() => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: urlendpoint,
    })
      .then((Response) => {
        setList1(Response.data);
        setFilteredItems(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Filtrar datos según el término de búsqueda
  useEffect(() => {
    const results = list1.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
    setFilteredItems(results);
    setCurrentPage(1); // Reiniciar a la página 1 después de una búsqueda
  }, [searchTerm, list1]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <ProtectedRoute>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Equipos</h3>
                <br></br>
                <CreaEquipos />
                <hr />
                <input
                  type="text"
                  placeholder="Buscar..."
                  className="form-control"
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Codigo</th>
                    <th scope="col">Fecha Fabricacion</th>
                    <th scope="col">Marca</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.codigo}</td>
                      <td>{item.fechaFabricacion}</td>
                      <td>{item.marca}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <Pagination
                  className="pagination justify-content-end mb-0"
                  listClassName="justify-content-end mb-0"
                >
                  {Array.from(
                    { length: Math.ceil(filteredItems.length / itemsPerPage) },
                    (_, i) => (
                      <PaginationItem key={i} active={i + 1 === currentPage}>
                        <PaginationLink
                          onClick={() => paginate(i + 1)}
                          href="#"
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ),
                  )}
                </Pagination>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </ProtectedRoute>
  );
};

export default Equipos;
